import React, { useState, useEffect } from 'react';
import { Modal, Button, ToggleButtonGroup, ToggleButton, Form } from 'react-bootstrap';
import Select from 'react-select';
import DateTime from '@bnsf/bnsf-date-time-picker';

import _ from 'lodash';

import { DATE_FORMAT } from '../../../constants/appConstants';
import { DATE_FILTER, WEEK, DEFAULT_FILTER } from './constants';

import GANG_IDS from '../../../data/mock_gang_ids';
import './FilterView.css';
import moment from 'moment';

/**
 *  @see ./constants/DEFAULT_FILTER for filter data structure and default values
 */ 
const FilterView = (props) => {
    const [show, setShow] = useState(false);
    const [filter, setFilter] = useState(_.cloneDeep(DEFAULT_FILTER));

    useEffect(() => {
        if ('show' in props) {
            setShow(props.show);
        }

        if (props.data) {
            // set filter structure from saved data filter
            const filterClone = _.cloneDeep(DEFAULT_FILTER);

            filterClone.gangIds = props.data.gangIds;
            filterClone.dateFilter.type = props.data.dateFilter.type;
            filterClone.dateFilter.value[props.data.dateFilter.type] = props.data.dateFilter.value;

            setFilter(filterClone);
        }

    }, [props.data, props.show]);

    const handleClose = () => {
        props.onHide && props.onHide();
    }

    const handleApply = () => { 
        const dataFilter = {
            dateFilter: {
                type: filter.dateFilter.type,
                value: filter.dateFilter.value[filter.dateFilter.type]
            },
            gangIds: filter.gangIds
        };

        props.onApply && props.onApply(dataFilter);
    }

    const onGangSelected = (selected) => {
        const newGangs = selected.map(opt => opt.value);

        setFilter(Object.assign({}, filter, { gangIds: newGangs }));
    }

    const onChange_dateType = (value) => {
        const filterClone = Object.assign({}, filter);
        filterClone.dateFilter.type = value;
        setFilter(filterClone);
    }

    const onChange_week = (event) => {
        const dateType = filter.dateFilter.type;
        const filterClone = Object.assign({}, filter);
        filterClone.dateFilter.value[dateType] = event.target.value;
        // const newDateFilter = Object.assign({}, filter.dateFilter, { value: event.target.value });
        setFilter(filterClone);
    };
    
    const onChange_startDate = (newDate) => {
        let filterClone = Object.assign({}, filter);

        if (filterClone.dateFilter.type === DATE_FILTER.BY_RANGE) {
            filterClone.dateFilter.value[DATE_FILTER.BY_RANGE].startDate = newDate;
        }
        
        setFilter(filterClone);
    }

    const onChange_endDate = (newDate) => {
        let filterClone = Object.assign({}, filter);

        if (filterClone.dateFilter.type === DATE_FILTER.BY_RANGE) {
            filterClone.dateFilter.value[DATE_FILTER.BY_RANGE].endDate = newDate;
        }
        
        setFilter(filterClone);
    }

    const dateOptions = {
        format: DATE_FORMAT
    };

    let startDate = '', endDate = '';
    if (filter.dateFilter.type === DATE_FILTER.BY_RANGE) {
        startDate = moment(filter.dateFilter.value[DATE_FILTER.BY_RANGE].startDate).format(DATE_FORMAT);
        endDate = moment(filter.dateFilter.value[DATE_FILTER.BY_RANGE].endDate).format(DATE_FORMAT);
    }

    const dateRangeItem = (
        <div className='clsFilterView-sub-block'>
            <div className='d-flex mb-1'>
                <div className='p-2 clsDateLabel'>Start Date</div>
                <div className='flex-grow-100'>
                    <DateTime key={"filterView_startDate"} placeholder='Start Date' pickerOptions={ dateOptions } value={ startDate } onDateChange= { onChange_startDate } />
                </div>
            </div>
            <div className='d-flex'>
                <div className='p-2 clsDateLabel'>End Date</div>
                <div className='flex-grow-100'>
                    <DateTime key={"filterView_endDate"} placeholder='End Date' pickerOptions={ dateOptions } value={ endDate } onDateChange= { onChange_endDate } />
                </div>                
            </div>
        </div>
    );

    const weekItem = (
        <div className='clsFilterView-sub-block'>
            <div className='d-flex flex-row clsWeekOptions'>
                <Form.Check type="radio" name="filterByWeek" id="week-previous"
                    label="Previous" value={WEEK.PREVIOUS}
                    checked={filter.dateFilter.value[filter.dateFilter.type] === WEEK.PREVIOUS}
                    onChange={onChange_week} className='clsOption me-3' />
                <Form.Check type="radio" name="filterByWeek" id="week-current"
                    label="Current" value={WEEK.CURRENT}
                    checked={filter.dateFilter.value[filter.dateFilter.type] === WEEK.CURRENT}
                    onChange={onChange_week} className='me-3' />
                <Form.Check type="radio" name="filterByWeek" id="week-next"
                    label="Next" value={WEEK.NEXT}
                    checked={filter.dateFilter.value[filter.dateFilter.type] === WEEK.NEXT}
                    onChange={onChange_week} />
            </div>
        </div>
    );

    const gangOptions = GANG_IDS.filter(gangOption => filter.gangIds.includes(gangOption.value));

    return (
        <Modal className='clsFilterView' show={show}>
            <Modal.Header>
                <Modal.Title>Filter</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='clsFilterView-block'>
                    <div className='clsFilterView-ctrl-label'>By Date</div>

                    <ToggleButtonGroup type="radio" name="dateFilterType"  
                            defaultValue={ filter.dateFilter.type }                             
                            onChange={ onChange_dateType }>
                        <ToggleButton className='btn btn-raised btn-secondary' value={DATE_FILTER.BY_TODAY}>Today</ToggleButton>
                        <ToggleButton className='btn btn-raised btn-secondary' value={DATE_FILTER.BY_WEEK}>Week</ToggleButton>
                        <ToggleButton className='btn btn-raised btn-secondary' value={DATE_FILTER.BY_RANGE}>Date Range</ToggleButton>
                    </ToggleButtonGroup>
                    { filter.dateFilter.type === DATE_FILTER.BY_RANGE ? dateRangeItem 
                        : filter.dateFilter.type === DATE_FILTER.BY_WEEK ? weekItem : null }
                </div>
                <div className='clsFilterView-block'>
                    <div className='clsFilterView-ctrl-label'>By Gang Id</div>
                    <Select multi
                        name = 'gangIds'
                        options = { GANG_IDS } 
                        noOptionsMessage = { () => 'No Result Found' } 
                        value = { gangOptions }
                        onChange = { onGangSelected } />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="clsBtn btn btn-bwwp-secondary" onClick={handleClose}>Close</Button>
                <Button className="clsBtn btn btn-bwwp-primary" onClick={handleApply}>Apply</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FilterView;